/**
 * The note under a live dataset's filter: what an empty filter does, and that
 * every count shown (the match line and each button's) covers the last 92 days
 * only as a guide — the filter itself has no period; each experiment pulls
 * the period picked when it runs. qFlow's count skips node rules, so with one
 * it is an upper bound.
 */

import { formatCount } from "@/lib/format";

export function FilterHint({
  matched,
  qflow = false,
  upperBound = false,
}: {
  matched: number | undefined;
  qflow?: boolean;
  /** The count leaves some filters out (qFlow node rules): at most this many. */
  upperBound?: boolean;
}) {
  const what = qflow ? "run" : "observation";
  return (
    <span className="flex flex-col gap-0.5">
      {matched !== undefined && (
        <span className="font-medium text-body">
          {upperBound ? `At most ${formatCount(matched)}` : formatCount(matched)} match in the last 92 days
          {upperBound ? " (node rules are applied when pulling)." : "."}
        </span>
      )}
      <span>
        Counts here cover the last 92 days, as a guide. The filter has no period of its own: each experiment
        pulls the period you pick when you run it. Leave it empty to pull every {what}.
      </span>
    </span>
  );
}
